import { SVG } from '../SVG'

export const GearIcon = ({ style = {}, ...props }) => (
  <SVG
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M11.5 15.8125C13.8817 15.8125 15.8125 13.8817 15.8125 11.5C15.8125 9.11827 13.8817 7.1875 11.5 7.1875C9.11827 7.1875 7.1875 9.11827 7.1875 11.5C7.1875 13.8817 9.11827 15.8125 11.5 15.8125Z' />
    <path d='M17.7351 7.24961C17.9514 7.55928 18.1408 7.88691 18.3011 8.22891L20.6281 9.52266C20.9186 10.824 20.9217 12.1731 20.6371 13.4758L18.3011 14.7695C18.1408 15.1115 17.9514 15.4392 17.7351 15.7488L17.78 18.4172C16.7939 19.3158 15.6267 19.9929 14.357 20.4027L12.066 19.0281C11.6891 19.0551 11.3108 19.0551 10.9339 19.0281L8.6519 20.3938C7.3782 19.9913 6.20716 19.3169 5.21987 18.4172L5.26479 15.7578C5.05031 15.4439 4.86105 15.1134 4.69878 14.7695L2.37182 13.4758C2.08127 12.1744 2.0782 10.8253 2.36284 9.52266L4.69878 8.22891C4.85913 7.88691 5.0485 7.55928 5.26479 7.24961L5.21987 4.58125C6.20604 3.6826 7.37323 3.00557 8.64292 2.5957L10.9339 3.97031C11.3108 3.94336 11.6891 3.94336 12.066 3.97031L14.348 2.60469C15.6217 3.00709 16.7927 3.68151 17.78 4.58125L17.7351 7.24961Z' />
  </SVG>
)
